import styled from "styled-components";

export const Container = styled.div.attrs({})`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Table = styled.table.attrs({})`
    border-collapse: separate;
    border-spacing: 0;

    border-radius: 12px;
    width: 100%;
    font-size: 12px;
    font-weight: 500;
    color: ${(props) => props.theme.palette.colors.text};

    background-color: white;
`;

export const Th = styled.th.attrs({})`
    color: var(--color-neutral-700);

    padding: 19px 0;
    font-weight: 500;
    text-align: center;

    width: 1000px;
`;

export const Tbody = styled.tbody.attrs({})`
    border: 1px solid black;
`;

export const Td = styled.td.attrs({})`
    padding: 16px 0;
    text-align: center;
    
    border-top: 1px solid ${(props) => props.theme.palette.colors.borderline};
`;

export const CreatorContainer = styled.div.attrs({})`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 30px;

    p {
        margin: 0;
        padding: 0;
    }
`;

export const PerfilImg = styled.img.attrs({})`
  width: 46px;
  height: 46px;
  object-fit: cover;
  border-radius: 50%;
`;

export const PlatformContainer = styled.div.attrs({})`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 12px;

    p {
        margin: 0;
        padding: 0;
    }
`;

export const Icon = styled.img.attrs(({ src }) => ({
  src,
}))`
    width: 26px;
    margin-Left: -5px;
`;

export const LabelContainer = styled.div.attrs({})`
  width: 62px;
  margin: 0 auto;

  border: 1px solid #A5A5A5;
  border-radius: 20px;
  padding: 8px 14px;
`;

export const MetricCardsContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 17px;
`;

export const MetricCard = styled.div.attrs({})`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 19px;
  border-radius: 12px;

  background-color: white;
`;

export const MetricCardText = styled.p.attrs({})`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.theme.palette.colors.text};

  background-color: white;

  margin: 0;
  padding: 0;
`;

export const MetricCardValue = styled.p.attrs({})`
  font-size: 20px;
  font-weight: 500;
  color: black;
  background-color: white;

  margin: 0;
  padding: 0;
`;